// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IClaimAppealDto
 */
export interface IClaimAppealDto {
    /**
     * 
     * @type {string}
     * @memberof IClaimAppealDto
     */
    description?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof IClaimAppealDto
     */
    document_fetch_urls?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof IClaimAppealDto
     */
    appeal_decision_status?: IClaimAppealDtoAppealDecisionStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof IClaimAppealDto
     */
    appeal_processing_note?: string;
}

/**
* @export
* @enum {string}
*/
export enum IClaimAppealDtoAppealDecisionStatusEnum {
    PENDING_REVIEW = 'PENDING_REVIEW',
    UNDER_REVIEW = 'UNDER_REVIEW',
    DOCS_NEEDED = 'DOCS_NEEDED',
    INCOMPLETE = 'INCOMPLETE',
    PARTIALLY_APPROVED = 'PARTIALLY_APPROVED',
    APPROVED = 'APPROVED',
    DENIED = 'DENIED',
    CANCELLED = 'CANCELLED',
    VOIDED = 'VOIDED'
}


/**
 * Check if a given object implements the IClaimAppealDto interface.
 */
export function instanceOfIClaimAppealDto(value: object): value is IClaimAppealDto {
    return true;
}

export function IClaimAppealDtoFromJSON(json: any): IClaimAppealDto {
    return IClaimAppealDtoFromJSONTyped(json, false);
}

export function IClaimAppealDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IClaimAppealDto {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'] == null ? undefined : json['description'],
        'document_fetch_urls': json['document_fetch_urls'] == null ? undefined : json['document_fetch_urls'],
        'appeal_decision_status': json['appeal_decision_status'] == null ? undefined : json['appeal_decision_status'],
        'appeal_processing_note': json['appeal_processing_note'] == null ? undefined : json['appeal_processing_note'],
    };
}

export function IClaimAppealDtoToJSON(json: any): IClaimAppealDto {
    return IClaimAppealDtoToJSONTyped(json, false);
}

export function IClaimAppealDtoToJSONTyped(value?: IClaimAppealDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'document_fetch_urls': value['document_fetch_urls'],
        'appeal_decision_status': value['appeal_decision_status'],
        'appeal_processing_note': value['appeal_processing_note'],
    };
}

